package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
data class Activity(
    val name: String,
    val enterprise: String,
    val city: String,
    val started: String,
    val ended: String,
    val description: String,
)